import React from 'react';
import { string, func } from 'prop-types';
import s from '../overviewWidget.module.css';
import MLButton from '../../../../components/MLButton';
import sButton from '../../../../components/MLButton/MLButton.module.css';

const DefaultOverviewWidget = ({
  performanceTab,
  widgetTitle,
  widgetDescription,
  btnText,
  onTabChange,
  diagnosticsUrl,
}) => (
  <div className={s.defaultOverviewCard}>
    {performanceTab && (
      <div>
        <h3>{widgetTitle}</h3>
        <p>{widgetDescription}</p>
        <MLButton
          ariaLabel={btnText}
          btnText={btnText}
          className={[s.defaultButton, sButton.btnSecondary, s.viewLinkThemed].join(' ')}
          onClick={() => {
            onTabChange(performanceTab);
          }}
        />
      </div>
    )}
    {diagnosticsUrl && (
      <div>
        <p>
          Visibility into your students&apos; course pre-requisite knowledge and
          skills.
        </p>
        <a
          href={diagnosticsUrl}
          el="noopener noreferrer"
          className={[s.viewLink, sButton.btnSecondary, s.viewLinkThemed].join(' ')}
        >
          View Diagnostics Report
        </a>
      </div>
    )}
  </div>
);
DefaultOverviewWidget.propTypes = {
  performanceTab: string,
  diagnosticsUrl: string,
  onTabChange: func,
  btnText: string,
  widgetTitle: string,
  widgetDescription: string,
};

export default DefaultOverviewWidget;
